// Default shipping partners configuration
export const DEFAULT_SHIPPING_PARTNERS: any[] = [
  {
    id: 1,
    name: "Giao hàng tiết kiệm",
    fee: 0,
    estimatedTime: "2 giờ",
    estimatedTimeNumber: 2,
    description: "Giao hàng tiết kiệm",
  },
  {
    id: 2,
    name: "Ahamove",
    fee: 0,
    estimatedTime: "2 giờ",
    estimatedTimeNumber: 2,
    description: "Siêu tốc",
  },
  {
    id: 3,
    name: "Ahamove",
    fee: 0,
    estimatedTime: "2 giờ",
    estimatedTimeNumber: 2,
    description: "Siêu tốc tiết kiệm",
  },
  {
    id: 4,
    name: "NV điều vận",
    fee: 0,
    estimatedTime: "",
    estimatedTimeNumber: 0,
    description: "Nội bộ Hacom",
  },
  {
    id: 5,
    name: "Kỹ thuật",
    fee: 0,
    estimatedTime: "",
    estimatedTimeNumber: 0,
    description: "Nội bộ Hacom",
  },
  {
    id: 6,
    name: "Dự án",
    fee: 0,
    estimatedTime: "",
    estimatedTimeNumber: 0,
    description: "Nội bộ Hacom",
  },
  {
    id: 7,
    name: "Kỹ thuật thi công",
    fee: 0,
    estimatedTime: "",
    estimatedTimeNumber: 0,
    description: "Nội bộ Hacom",
  },
  {
    id: 8,
    name: "COD",
    fee: 0,
    estimatedTime: "từ 02 đến 06 ngày",
    estimatedTimeNumber: 144, // 6 ngày * 24 giờ
    description: "COD",
  },
  {
    id: 9,
    name: "Grab",
    fee: 0,
    estimatedTime: "2 giờ",
    estimatedTimeNumber: 2,
    description: "GrabExpress",
  },
];

// Shipping type options
export const SHIPPING_TYPE_OPTIONS = [
  "Nội bộ Hacom",
  "Xfast",
  "Hỏa tốc",
  "Thường",
  "Siêu tốc",
  "Siêu tốc tiết kiệm",
  "COD",
  "GrabExpress",
];
